import { ApiEndpoints } from "./apiEndpoints";
import { fetchData, setHeaderOptions } from "./apiHelpers";
import {
  GroupChatMemberRowWithUser,
  GroupChatRow,
  GroupChatRowWithLatestMessage,
} from "./groupChat.type";
import { MessageRow } from "./message.type";

export const getGroupChats = async (): Promise<
  GroupChatRowWithLatestMessage[]
> => {
  const slug = ApiEndpoints.groupChat + "/";
  const options = await setHeaderOptions({ method: "GET" });
  return fetchData<GroupChatRowWithLatestMessage[]>(slug, options);
};

export const getGroupChat = async (id: string): Promise<GroupChatRow> => {
  const slug = ApiEndpoints.groupChat + `/${id}`;
  const options = await setHeaderOptions({ method: "GET" });
  return fetchData<GroupChatRow>(slug, options);
};

export const getGroupChatMembers = async (
  groupChatId: string
): Promise<GroupChatMemberRowWithUser[]> => {
  const slug = `${ApiEndpoints.groupChatMember}/group-chat/${groupChatId}`;
  const options = await setHeaderOptions({ method: "GET" });
  return fetchData<GroupChatMemberRowWithUser[]>(slug, options);
};

export const createGroupChat = async ({
  name,
  description,
  created_by,
}: {
  name: string;
  description?: string;
  created_by: string;
}): Promise<GroupChatRow> => {
  const slug = ApiEndpoints.groupChat + "/";
  const options = await setHeaderOptions({
    method: "POST",
    body: { name, description, created_by },
  });
  return fetchData<GroupChatRow>(slug, options);
};

export const addMemberToGroupChat = async ({
  groupChatId,
  userId,
}: {
  groupChatId: string;
  userId: string;
}): Promise<void> => {
  const slug = `${ApiEndpoints.groupChatMember}/${groupChatId}`;
  const options = await setHeaderOptions({
    method: "POST",
    body: { userId },
  });
  await fetchData<void>(slug, options);
};

export const removeMemberFromGroupChat = async ({
  memberId,
}: {
  memberId: string;
}): Promise<void> => {
  const slug = `${ApiEndpoints.groupChatMember}/${memberId}`;
  const options = await setHeaderOptions({ method: "DELETE" });
  await fetchData<void>(slug, options);
};

export const updateGroupChat = async ({
  id,
  name,
  description,
}: {
  id: string;
  name?: string;
  description?: string;
}): Promise<GroupChatRow> => {
  const slug = `${ApiEndpoints.groupChat}/${id}`;
  const options = await setHeaderOptions({
    method: "PUT",
    body: { name, description },
  });
  return fetchData<GroupChatRow>(slug, options);
};

export const seedGroupChatMessage = async ({
  groupChatId,
  memberId,
  content,
}: {
  groupChatId: string;
  memberId: string;
  content: string;
}): Promise<MessageRow> => {
  const slug = `${ApiEndpoints.groupChat}/${groupChatId}/seed-message`;
  const options = await setHeaderOptions({
    method: "POST",
    body: { memberId, content },
  });

  return fetchData<MessageRow>(slug, options);
};
